import React from "react";
import { makeStyles } from "@material-ui/core";
import { KIcon, KSelect } from "@kyburz/kdesign-system";

const useStyles = makeStyles(() => ({
  wrapper: {
    paddingBottom: 16,
  },
  root: {
    position: "sticky",
    marginTop: 2,
    top: -2,
    padding: "16px 0",
    background: "white",
    zIndex: 10,
  },
  columns: {
    fontSize: 16,
    fontWeight: 500,
    display: "flex",
    justifyContent: "space-between",
  },
  subColumns: {
    marginTop: 0,
    color: "#bdbdbd",
    display: "flex",
    justifyContent: "space-between",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
}));

interface Props {
  csv: any;
  columnArray: any;
  toRemove: any;
  dropdownElements: any;
  handleSelectChange: any;
}

const CSVMapper: React.FC<Props> = ({
  csv,
  columnArray,
  toRemove,
  dropdownElements,
  handleSelectChange,
}: Props) => {
  const classes = useStyles();
  const csvColumns =
    csv[0]?.data.length === 1 ? csv[0]?.data[0].split(";") : csv[0]?.data;

  return (
    <div className={classes.wrapper}>
      <div className={classes.root}>
        <div className={classes.columns}>
          <div>Columns from CSV</div>
          <KIcon icon="arrow-right" />
          <div>map to</div>
          <KIcon icon="arrow-right" />
          <div>Parameters</div>
        </div>
      </div>
      {csvColumns
        ?.filter((x) => !toRemove.includes(x))
        .map((x) => (
          <div className={classes.row} key={x}>
            <div>
              <div style={{ maxWidth: 320 }}>{x}</div>
            </div>
            <KSelect
              elements={dropdownElements}
              name={x}
              isClearable
              onSelect={(value, name) => handleSelectChange(value, name, x)}
              value={
                columnArray.map((y) => y.column).includes(x.split(".").pop())
                  ? columnArray.find((z) => z.column === x.split(".").pop())
                      .mappedValue
                  : ""
              }
            />
          </div>
        ))}
    </div>
  );
};

export default CSVMapper;
